import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../services/Authentication";

import "./Subjects.scss";
import Button from "../controls/buttons/Button";
import SubjectCard from "./SubjectCard/SubjectCard";
import NewSubject from "./NewSubject/NewSubject";
import app from "../../services/base";
import ViewSubject from "./ViewSubject/ViewSubject";
import Grid from '@material-ui/core/Grid';
import AlertDialog from "../modal";










function Subjects() {

  const [showLoading, setShowLoading] = useState(false);
  const [SubjectList, setSubjectList] = useState([]);
  const [subject, setSubject] = useState('');
  const [filteredSubjectList, setFilteredSubjectList] = useState([]);
  const [subjectFilter, setSubjectFilter] = useState('');
  const [communityListAdm, setCommunityListAdm] = useState([]);
  const [subjectScreen, setSubjectScreen] = useState('main');
  const [canCreate, setCanCreate] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalAction, setModalAction] = useState({});
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {

    getSubjects();


  }, []);

  const getSubjects = async () => {
    setShowLoading(true);



    let events = await app
      .firestore()
      .collection("events")
      .where("attendersId", "array-contains", currentUser.id)
      .get();

    


    const eventsAdm = [];
    const eventsList = [];
    for (const elem of events.docs) {
      const isManager = elem.data().manager && elem.data().manager.some(item => item.userId === currentUser.id && item.level >= 3);
      if (isManager) {
        eventsAdm.push(elem.data().id)
      }
      else {
        eventsList.push(elem.data().id)
      }
    }
    let communities;

    if (eventsList.length > 0) {
      communities = await app
        .firestore()
        .collection("connections")
        .where("eventId", "in", eventsList)
        .where("users","array-contains",currentUser.id)
        .where("chatType","==","GroupChat")
        .get();


        
    }

    let communitiesAdm;

    if (eventsAdm.length > 0) {
      communitiesAdm = await app
        .firestore()
        .collection("connections")
        .where("eventId", "in", eventsAdm)
        .where("users","array-contains",currentUser.id)
        .where("chatType","==","GroupChat")
        .get();

    }




    let communityList = [];
    let communityListAdm = [];
    let communityListIds = [];
    let communityListIdsAdm = [];
    let subjectList = []

    if (communities) {
      for (const elem of communities.docs) {

        communityList.push({
          title: elem.data().groupInfo.title,
          id: elem.data().id,
          admin: false
        })
        communityListIds.push(elem.data().id);
      }
    }


    if (communitiesAdm) {
      for (const elem of communitiesAdm.docs) {
        communityList.push({
          title: elem.data().groupInfo.title,
          id: elem.data().id,
          admin: true
        })
        communityListIdsAdm.push(elem.data().id);
      }
    }




    if (communityListIds.length > 0 || communityListIdsAdm.length > 0) {

      let subjects;
      let subjectsAdm;


      if (communityListIds.length > 0) {
        subjects = await app
          .firestore()
          .collection("disciplina")
          .where("groupIds", "array-contains-any", communityListIds)
          .get();
      }

      if (communityListIdsAdm.length > 0) {
        subjectsAdm = await app
          .firestore()
          .collection("disciplina")
          .where("groupIds", "array-contains-any", communityListIdsAdm)
          .get();
      }

      if (subjects) {
        for (const elem of subjects.docs) {

          subjectList.push({...elem.data(),
            lastUpdate: elem.data().lastUpdate.toDate(),
            admin: false
          })
        }
      }

      if (subjectsAdm) {
        for (const elem of subjectsAdm.docs) {
          subjectList.push({...elem.data(),
            lastUpdate: elem.data().lastUpdate.toDate(),
            admin: true
          })

        }
      }




      setSubjectList(subjectList);
    }


    if (communityList.some(item => { return item.admin })) {
      setCanCreate(true);
      communityList.forEach(el => {
        if (el.admin) {
          communityListAdm.push(el);
        }
      })
    }


    setCommunityListAdm(communityListAdm);
    setShowLoading(false);
  };


  function handleChange(e, newValue) {
    if (newValue == 'main') {
      setSubject('');
      setSubjectFilter('');
      setSubjectScreen('main');
      getSubjects();
    }
    else {
      setSubjectScreen(newValue);
    }
  };

  function handleEdit(subject) {
    setSubject(subject);
    setSubjectScreen('edit');
  };

  function handleView(subject) {
    setSubject(subject);
    setSubjectScreen('view');
  };

  function handleDelete(subject) {

    setModalAction({
      actionConfirmation: () => {

        deleteSubject(subject);
      },
      title: "Tem certeza que deseja excluir a disciplina " + subject.name + "?",
      legend:
        "Esta é uma ação irreversível",
      buttonConfirmation: true,
      actionCancel: () => setOpen(false),
    });
    setOpen(true);
  }

  async function deleteSubject(subject) {
    setShowLoading(true)
    let D = await app
      .firestore()
      .collection("disciplina")
      .where("subjectId", "==", subject.subjectId)
      .get();

    for (const elem of D.docs) {
      elem.ref.delete();
    }
    setOpen(false);
    getSubjects();
  }

  function renderSubjects() {
    let array = subjectFilter !== '' ? filteredSubjectList : SubjectList;
    let subjects = [];
    array.forEach(el => {
      subjects.push(
        <SubjectCard subject={el} handleEdit={() => handleEdit(el)} handleView={() => handleView(el)} handleDelete={() => handleDelete(el)} />
      )
    });
    return subjects;
  }


  const searchSubjects = (text) => {
    setSubjectFilter(text);
    if (text !== '') {
      const filteredSubjects = SubjectList.filter((item) => {
        return item.name.toLowerCase().includes(text);
      });
      setFilteredSubjectList(filteredSubjects);
    }
    else {
      setFilteredSubjectList(SubjectList);
    }

  }

  return (
    <div>
      {subjectScreen == 'main' && <div className="subjects-main">
        <AlertDialog open={open} {...modalAction} />
        <div className="subjects-container">
          {showLoading && <div class="loader" />}
          <span className="title-subjects">Disciplinas</span>
          <div className="subjects-header">
            <div>
              <span className="subtitle-subjects">Gerenciar disciplinas</span>
            </div>
          </div>
          <div className="search-header">
            <Grid container spacing={3}>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <div className="search-subjects">
                  <input
                    type="text"
                    placeholder="Buscar disciplina"
                    value={subjectFilter}

                    onChange={(e) => {
                      searchSubjects(e.target.value);
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={3}>
                {canCreate && <label onClick={(e) => handleChange(e, 'new')}>
                  <Button >
                    <span>Nova disciplina +</span>
                  </Button>
                </label>}
              </Grid>
            </Grid>



          </div>

        </div>
        <Grid container>
          <Grid item xs={12}>
            <div className="subjects-card-container">
              {SubjectList.length > 0 &&
                renderSubjects()}
            </div>
          </Grid>
        </Grid>

      </div>}
      {subjectScreen == 'new' && <NewSubject communityList={communityListAdm} changeScreen={handleChange} />}
      {subjectScreen == 'edit' && subject && <NewSubject communityList={communityListAdm} changeScreen={handleChange} subject={subject} />}
      {subjectScreen == 'view' && subject && <ViewSubject communityList={communityListAdm} changeScreen={handleChange} subject={subject} />}
    </div>

  );
}

export default Subjects;
